import { Investment } from "./style";
import Assinatura from "../../../../assets/assinatura-orange.webp"
import backInvestiment from "../../../../assets/wallpaper-investment.webp"


function InvestmentComponent() {
  return (
    <Investment backInvestiment={backInvestiment}>
      <div id="pather-div">
        <div id="children-div-text">
          <div id="title-div">
            <span>SIM, é isso mesmo!</span>
            <h1>Você vai ter um investimento 70% menor</h1>
          </div>
          <p id="paragraph">
            <span id="span-bold">
              Você vai ganhar <span id="span-orange">1 ano e 4 meses</span> em
              tempo e economizar <span id="span-orange">R$ 8.700,00</span> em
              dinheiro!
            </span>{" "}
            Essa é a economia em tempo e dinheiro. Por um programa customizado
            através do Processo Comportamental&#169;.
          </p>
        </div>
        <div id="children-div-img">
            <figure>
                <img src={Assinatura} alt="text" />
            </figure>
        </div>
      </div>
    </Investment>
  );
}

export default InvestmentComponent;
